import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

// Mirrors the coarse gate used for Email/Push channels in campaign creation
// (see capabilities.ts `hasLotusCrmCampaign`). The per-retailer emailCapable/
// pushCapable check from useSfpRetailerSiteContext runs inside the page after
// the retailer/store-config scope is known — it can't be expressed here.
export const standaloneUnsubscribeListsAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.MarketingToolingViewAccess],
    featureToggles: [
      FeatureToggle.standaloneUnsubscribeListsEnabled,
      FeatureToggle.enableLotusCRMCampaign,
    ],
  },
]
